import { useState, useEffect } from 'react'
import { getLocalPath } from '../config/configuration'
import { fetchData } from '../../data'

export function useTaxonomies(
  shouldFetchRawData = false,
  ignoredTaxonomies = []
) {
  const [taxonomies, setTaxonomies] = useState([])

  const flatternTaxonomyData = (taxonomyCategories = []) => {
    const flatternTaxonomies = []

    const getAllKeys = (taxonomiesCategories, flatKeys) => {
      for (const category of taxonomiesCategories) {
        flatKeys.push({
          key: category.key,
          name: category.infos?.en_US?.name || category.infos?.en?.name || '',
        })

        if (
          Array.isArray(category.categories) &&
          category.categories.length > 0
        ) {
          getAllKeys(category.categories, flatKeys)
        }
      }
    }

    getAllKeys(taxonomyCategories, flatternTaxonomies)

    return flatternTaxonomies
  }

  const filterIgnoredTaxonomiesFromList = (taxonomies) => {
    const { categories = [] } = taxonomies
    return categories.filter((category) => {
      return !ignoredTaxonomies.includes(category.key)
    })
  }

  const fetchAsync = async () => {
    const documentUrl = `${getLocalPath()}/halapi/taxonomies/Blog%20Categories`

    const completeTaxonomiesData = await fetchData(documentUrl)
    const taxonomyCategories = ignoredTaxonomies.length
      ? filterIgnoredTaxonomiesFromList(completeTaxonomiesData)
      : completeTaxonomiesData?.categories || []
    if (shouldFetchRawData) {
      setTaxonomies(taxonomyCategories)
    } else if (taxonomyCategories.length) {
      const flatternTaxonomies = flatternTaxonomyData(taxonomyCategories)

      try {
        sessionStorage.setItem(
          'INSTITUTIONAL-TAXONOMIES',
          JSON.stringify(flatternTaxonomies)
        )
        sessionStorage.setItem(
          'IGNORED-TAXONOMIES',
          JSON.stringify(ignoredTaxonomies)
        )
        /* eslint-disable-next-line no-empty */
      } catch (e) {}

      setTaxonomies(flatternTaxonomies)
    }
  }

  useEffect(() => {
    let taxonomiesData
    const ignoredTaxonomiesFromStorage =
      JSON.parse(sessionStorage.getItem('IGNORED-TAXONOMIES')) || []
    const shouldFetchNewTaxonomies = !ignoredTaxonomiesFromStorage
      .slice()
      .sort()
      .every(
        (value, index) => value === ignoredTaxonomies.slice().sort()[index]
      )

    if (shouldFetchRawData || shouldFetchNewTaxonomies) {
      fetchAsync()
    } else {
      try {
        taxonomiesData = sessionStorage.getItem('INSTITUTIONAL-TAXONOMIES')
        /* eslint-disable-next-line no-empty */
      } catch (e) {}

      if (taxonomiesData) {
        try {
          taxonomiesData = JSON.parse(taxonomiesData)
          /* eslint-disable-next-line no-empty */
        } catch (e) {}
      }

      if (taxonomiesData?.length > 0) {
        setTaxonomies(taxonomiesData)
      } else {
        fetchAsync()
      }
    }
  }, [])

  return taxonomies
}
